export { default } from './PMCAdsense';
